import { FormsEnum, PersonType } from 'app/shared/enums';
import { validateIsUniquePesel } from 'app/validators';
import { isPeselMatchingLicenseDate, isPeselValid } from '.';
import {
  getCheckoutCoownersData,
  getCheckoutOwnerData,
  getQuestion,
  getQuotation,
  setMessageVisibility,
} from '../businessFunctionHelpers';
import { setFamilyNameVisibility } from '../businessFunctions/helpers/setFamilyNameVisibility';
import { checkoutOwnersPeselKeys } from './peselsKeys';

/**
 * Validates checkout pesels and sets error messages visibility.
 *
 * @return {boolean} is pesel correct.
 */
export function validateCheckoutPesel(person: PersonType): boolean {
  const formName = FormsEnum.CheckoutForm;
  const minAge =
    getQuestion(checkoutOwnersPeselKeys.questionField[person], formName)
      .minAge || 13;
  let pesel: string,
    personInfo,
    driverLicenseYear: string | number | undefined,
    driverLicenseMonth: string | number | undefined;

  switch (person) {
    case PersonType.Owner:
      pesel = getCheckoutOwnerData().peselCheckoutForm || '';
      personInfo = getQuotation()?.mainOwner || {
        driverLicenseIssuedYear: 0,
        driverLicenseIssuedMonth: 0,
      };
      break;
    case PersonType.Coowner1:
      pesel = getCheckoutCoownersData()[1].peselCheckoutForm || '';
      personInfo = getQuotation()?.coOwners || [];
      personInfo = personInfo[0] || {
        driverLicenseIssuedYear: 0,
        driverLicenseIssuedMonth: 0,
      };
      break;
    case PersonType.Coowner2:
      pesel = getCheckoutCoownersData()[2].peselCheckoutForm || '';
      personInfo = getQuotation()?.coOwners || [];
      personInfo = personInfo[1] || {
        driverLicenseIssuedYear: 0,
        driverLicenseIssuedMonth: 0,
      };
      break;
    case PersonType.Insurant:
      return true;
  }

  driverLicenseYear = personInfo.driverLicenseIssuedYear;
  driverLicenseMonth = personInfo.driverLicenseIssuedMonth;

  let isValid = isPeselValid(pesel);
  if (isValid) {
    setMessageVisibility({
      formName,
      key: checkoutOwnersPeselKeys.invalidPeselMessage[person],
      visible: false,
    });
  }
  isValid = isPeselValid(pesel, minAge);
  if (isValid) {
    setMessageVisibility({
      formName,
      key: checkoutOwnersPeselKeys.tooYoungOwnerPeselMessage[person],
      visible: false,
    });
  }

  const isMatchingLicenseDate = !!isPeselMatchingLicenseDate({
    pesel,
    driverLicenseYear,
    driverLicenseMonth,
    noDriverLicenseModelPath:
      checkoutOwnersPeselKeys.noDriverLicenseModelPath[person],
  });
  setMessageVisibility({
    formName,
    key: checkoutOwnersPeselKeys.peselAndLicenseYearMismatchMessage[person],
    visible: isValid && isMatchingLicenseDate === false,
  });

  if (pesel === '') return true;

  const isPeselUnique = validateIsUniquePesel({
    value: pesel,
    questionKey: checkoutOwnersPeselKeys.questionField[person],
    formName,
  });

  const isPeselCorrect = isValid && isMatchingLicenseDate && isPeselUnique;

  setFamilyNameVisibility(
    checkoutOwnersPeselKeys.familyNameField[person],
    FormsEnum.CheckoutForm,
    pesel,
    isPeselCorrect
  );

  return isPeselCorrect;
}
